import LocalizedDataGrid from "../../../components/LocalizedDataGrid";
import {
	Box
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { min } from "underscore";

const ROW_HEIGHT = 50;
const DEFAULT_PAGE_SIZE = 10

const MeteringTable = ({ energyData, currencySymbol, filteredBy }) => {

	const { t } = useTranslation();

	const data = {};

	const firstColumnName = filteredBy === "location" ? t("Location") : t("System");


	energyData.categories?.forEach((c) => {
		data[c] = {
			cost: null,
			consumption_kwh: null,
			co2_kg: null
		}
	})

	if (energyData.cost)
		Object.entries(energyData.cost).forEach(([k, v]) => {
			data[k].cost = v.reduce((acc, val) => acc + val, 0.0)
		})
	if (energyData.consumption_kwh)
		Object.entries(energyData.consumption_kwh).forEach(([k, v]) => {
			data[k].consumption_kwh = v.reduce((acc, val) => acc + val, 0.0)
		})
	if (energyData.co2_kg)
		Object.entries(energyData.co2_kg).forEach(([k, v]) => {
			data[k].co2_kg = v.reduce((acc, val) => acc + val, 0.0)
		})


	const columns = [{
		field: 'name',
		headerName: firstColumnName,
		minWidth: 150,
		flex: 1
	}, {
		field: 'consumption_kwh',
		headerName: t('kWh'),
		minWidth: 150,
		valueFormatter: (v) => v.value?.toLocaleString(undefined, { maximumFractionDigits: 0 }),
		flex: 1
	}, {
		field: 'cost',
		headerName: t("Cost") + ` (${currencySymbol})`,
		minWidth: 150,
		valueFormatter: (v) => v.value?.toLocaleString(undefined, { maximumFractionDigits: 0 }),
		flex: 1
	}, {
		field: 'co2_kg',
		headerName: "kgCO2",
		minWidth: 150,
		valueFormatter: (v) => v.value?.toLocaleString(undefined, { maximumFractionDigits: 0 }),
		flex: 1
	}]

	return (
		<Box sx={{ height: min([(ROW_HEIGHT * Object.keys(data).length) + 110, (ROW_HEIGHT * DEFAULT_PAGE_SIZE) + 110]), width: '100%', backgroundColor: (theme) => theme.palette.background.paper }}>
			<LocalizedDataGrid
				rows={Object.entries(data).map(([k, v]) => ({ name: k, ...v }))}
				columns={columns}
				getRowId={(row) => row.name}
				experimentalFeatures={{ newEditingApi: true }}
				rowHeight={ROW_HEIGHT}
				pageSize={DEFAULT_PAGE_SIZE}
				rowsPerPageOptions={[DEFAULT_PAGE_SIZE, 20, 50, 100]}
			/>
		</Box>
	);
};

export default MeteringTable;
